module.exports = __webpack_public_path__ + "assets/e781f83823a64318b14cb8f20b366566.mp3";